import React, { useState } from "react";
import { RiUser6Line } from "react-icons/ri";
import { HiOutlineLockClosed } from "react-icons/hi2";
import { LuHeadset } from "react-icons/lu";
import apiRequests from "../axios/config/config";
import toast from "react-hot-toast";
import WebLogo from "../../font & image/image/webLogo.png";
import gmail from "../../font & image/image/gmail.png";
import Loading from "../Loading/Loading";
import { useNavigate } from "react-router-dom";
import bannerImage from "../../font & image/image/imageLoginPage.png";
import loginArt from "../../font & image/image/loginArt.png";
import { BsEye, BsEyeSlash } from "react-icons/bs";
export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  function loginAPI(e) {
    e?.preventDefault();

    setLoading(true);

    apiRequests
      .post("/api/admin/v1/login", {
        userName: username,
        password: password,
      })
      .then((response) => {
        localStorage.setItem(
          "accessToken",
          response.data.data.tokens.accessToken,
        );
        toast.success("Login successful");
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response?.data?.en_message || "Login failed");
      })
      .finally(() => setLoading(false));
  }

  return (
    <div className="grid grid-cols-2 md:flex md:h-screen md:justify-center md:items-center">
      <div className="flex justify-center h-full items-center p-3 text-center col-span-1 ">
        <form
          onSubmit={loginAPI}
          className="text-black border-2 overflow-hidden rounded-lg bg-white p-8 w-[60%] md:w-full items-center justify-center flex flex-col gap-5"
        >
          <div className="flex items-center justify-center gap-4">
            <img src={WebLogo} alt="webLogo" width={32} height={32} />
            <p className="text-3xl font-bold italic">Clan Smart</p>
          </div>

          <div className="flex flex-col justify-start gap-1 w-full">
            <p className="text-xl text-left">User Name</p>
            <div className="bg-[#D9D9D9] flex items-center justify-between px-5 py-2 rounded-lg ">
              <input
                className="bg-transparent outline-0 placeholder:text-lg px-2 py-1 outline-none w-full"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter Your Username..."
              />
              <RiUser6Line className="text-[18px] text-firstColor-shade5" />
            </div>
          </div>

          <div className="flex flex-col justify-start gap-1 w-full">
            <p className="text-xl text-left">Password</p>
            <div className="bg-[#D9D9D9] flex items-center justify-between px-5 py-2 rounded-lg">
              <input
                className="bg-transparent outline-0 placeholder:text-lg px-2 py-1 outline-none w-full"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter Your Password..."
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="text-firstColor-shade5 hover:text-gray-700 transition"
              >
                {showPassword ? (
                  <BsEyeSlash className="text-[18px]" />
                ) : (
                  <BsEye className="text-[18px]" />
                )}
              </button>{" "}
            </div>
          </div>

          {/*<div className="hover:text-blue-400 hover:cursor-pointer">Forget Your Password ?</div>*/}

         <button
  type="submit"
  className="bg-buttonColor-shade6 w-full text-white px-5 py-2 rounded-lg"
>
  {loading ? <Loading textColor="white-0" /> : "Sign In"}
</button>
        </form>{" "}
      </div>

      <div className="col-span-1 h-screen p-5 md:hidden flex items-center justify-center">
        <img
          src={loginArt}
          alt="banner"
          className="max-w-full max-h-full w-auto h-auto object-contain"
        />
      </div>
    </div>
  );
}
